<ng-container *ngIf="visitDetails else visitDetailsLoadingError">
  <div class="container-narrow my-5">
    <h1 class="visually-hidden"
        [translate]="'BOOKING-PART.BOOKING-COMPLETED.PAGE-TITLE'">
    </h1>

    <app-booking-confirmed />

    <app-gifts-info
      *ngIf="salonAllowsGifts"
      [visitId]="visitDetails.visitId"
    />

    <app-payment-successful
      *ngIf="paymentSuccessful"
      [paymentType]="paymentType"
      class="mb-3"
    />

    <app-account-created *ngIf="accountCreated" />

    <app-booking-completed-summary
      [currentLang]="currentLang"
      [visitDetails]="bookingCompletedVisitDetails"
    />
  </div>

  <div *ngIf="shouldShowBookAnotherVisitButton"
       class="container-narrow mt-5 d-flex justify-content-center">
    <div class="col-12 col-md-6 mt-3 mt-md-0">
      <button [translate]="'BOOKING-PART.BOOKING-COMPLETED.BUTTON-ANOTHER-VISIT'"
              (click)="bookAnotherVisit()"
              class="btn btn-cta btn-lg btn-block shadow-sm">
      </button>
    </div>
  </div>

  <div *ngIf="shouldRedirectToSalonWebpageOnRouteBySalonId"
       class="row mt-3 d-flex justify-content-center">
    <div class="col-12 col-md-6 mt-3 mt-md-0">
      <button class="btn btn-link btn-lg btn-block"
              (click)="returnToSalonWebsite()">
        <span [translate]="'BOOKING-PART.BOOKING-COMPLETED.BUTTON-RETURN-TO-WEBSITE'"
              [translateParams]="{timeLeft: countdownRedirectInSeconds}">
          {{ 'BOOKING-PART.BOOKING-COMPLETED.BUTTON-RETURN-TO-WEBSITE' | translate: {timeLeft:
          countdownRedirectInSeconds} }}
        </span>
      </button>
    </div>
  </div>

  <app-gifts-list
    *ngIf="salonAllowsGifts"
    [visitId]="visitDetails.visitId"
  />
</ng-container>

<ng-template #visitDetailsLoadingError>
  <div class="container-narrow my-5">
    <div class="row mt-5">
      <div class="col-12">
        <h1 [translate]="'BOOKING-PART.COMMON-ERRORS.VISIT-DETAILS.TITLE'"
            class="h3 fw-bolder">
        </h1>
        <p [translate]="'BOOKING-PART.COMMON-ERRORS.VISIT-DETAILS.DESCRIPTION'"
           class="pre-wrap">
        </p>
      </div>
    </div>
  </div>
</ng-template>
